import { message } from 'antd';
import { eventBus, EVENTS } from './eventBus';

export const handleApiError = (error, fallbackMessage = '请求失败') => {
  console.error('API Error:', error);
  
  // 尝试从错误响应中提取详细信息
  let errorMessage = fallbackMessage;
  
  if (error.response) {
    // 服务器返回了错误响应
    try {
      const data = error.response.data;
      errorMessage = data.message || data.error || `错误 (${error.response.status})`;
      
      // 处理 401 未授权错误
      if (error.response.status === 401) {
        eventBus.emit(EVENTS.AUTH_ERROR, {
          status: error.response.status,
          message: errorMessage
        });
        message.error('登录已过期，请重新登录');
        // 重定向到登录页面
        window.location.href = '/login';
      }
    } catch (e) {
      errorMessage = `服务器错误 (${error.response.status})`;
    }
  } else if (error.request) {
    // 请求发送了但没有收到响应
    errorMessage = '服务器无响应，请检查网络连接';
  } else if (error.message) {
    // 使用错误对象自带的消息
    errorMessage = error.message;
  }
  
  // 显示错误消息
  message.error(errorMessage);
  
  return errorMessage;
}; 